import { Box, CircularProgress, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import dayjs from 'dayjs';
import { useContext, useState } from 'react';
import CommentsWrap from '@/components/comments_components/CommentsWrap';
import { CurrentApplicationContext } from '@/Contexts/CurrentApplicationContext';
import { QuestionProps } from '@/models/Question';
import useQuestions from '../../../hooks/useQuestions';

export default function Year({ question }: { question: QuestionProps }) {
  const { getMaxDate, validDateTime } = useQuestions();

  const { answers, makingApiRequest, canEdit, saveApplicationAnswer2, applicationCycle } =
    useContext(CurrentApplicationContext);

  const [loading, setLoading] = useState<boolean>(false);

  const questionAnswer = answers[question.id];
  const [currentValue, setCurrentValue] = useState(questionAnswer?.responseInt ?? null);

  const handleChanged = async (newValue: dayjs.Dayjs | null) => {
    setCurrentValue(newValue?.year() ?? null);

    if (newValue != null && !validDateTime(question, applicationCycle!, newValue)) return;
    setLoading(true);
    await saveApplicationAnswer2(question, newValue != null ? newValue?.year() : null).then(() => {
      setLoading(false);
    });
  };

  return (
    <Box display='flex' width='100%' justifyContent='space-between' alignItems='start'>
      <Box display='flex' flexDirection='column'>
        <Typography>{question.questionText}</Typography>
        <Box display='flex' alignItems='center'>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              sx={{
                marginTop: '7px',
              }}
              value={currentValue != null ? dayjs(currentValue.toString()) : null}
              label={'Select Year'}
              views={['year']}
              maxDate={getMaxDate(question, applicationCycle)}
              onChange={handleChanged}
              disabled={!canEdit || makingApiRequest}
              slotProps={{ field: { clearable: true } }}
            />
          </LocalizationProvider>
          {loading && (
            <div
              style={{
                display: 'inline-block',
                position: 'relative',
                top: '3px',
                width: '20px',
                height: '20px',
                marginLeft: '10px',
              }}
            >
              <CircularProgress size='22px' />
            </div>
          )}
        </Box>
      </Box>

      <CommentsWrap question={question} />
    </Box>
  );
}
